<div (click)="open()">
  @if (bookChapter) {
    <button mat-button><span>{{ verseReference() }}</span><mat-icon iconPositionEnd>arrow_drop_down</mat-icon></button>
  } @else {
    <button mat-button><span>Book</span><mat-icon iconPositionEnd >arrow_drop_down</mat-icon></button>
  }
</div>
